import http from '@/support/plugin/axios'

export const 

//Pega todos os prêmios
getPendingPrizesByCompanyIdAndCurrentContactId = ( companyId ) => http.get(`companies/${companyId}/contacts/current/prizes/pending`)